export const INITIAL_STAGE_STEPPER_STEPS = [
  { id: 'stage1', label: 'Stage 1' },
  { id: 'stage2', label: 'Stage 2' },
];

/**
 * Build the Initial Certification stage overview from authoritative BE gate
 * state. Technical Review is represented by the main audit workflow stepper and is not
 * duplicated in this compact Stage 1/Stage 2 overview.
 *
 * trDecision: latest TR decision ("OK" | "NEED_REVISION" | null).
 * When NEED_REVISION: Stage 2 stays current + needsRevision flag so the auditor can revise
 * the Stage 2 forms. (2B.3)
 */
export const buildInitialStageStepper = ({
  gate,
  trDecision = null,
} = {}) => {
  if (!gate || !gate.activeStage) return null;

  const activeStage = String(gate.activeStage).toLowerCase();
  const trNeedsRevision = trDecision === 'NEED_REVISION';
  const allCompleted = activeStage === 'completed' && !trNeedsRevision;

  const states = {
    stage1: {
      completed: Boolean(gate.stage1Completed) || activeStage === 'stage2' || allCompleted,
      current: activeStage === 'stage1',
      locked: false,
    },
    stage2: {
      completed: allCompleted,
      current: activeStage === 'stage2' && !allCompleted,
      locked: false,
      needsRevision: trNeedsRevision,
    },
  };

  return {
    activeStage,
    trNeedsRevision,
    steps: INITIAL_STAGE_STEPPER_STEPS.map((step) => ({ ...step, ...states[step.id] })),
  };
};
